






import Vue from "vue";

export default Vue.extend({
  data() {
    return {
      imgAgenda: "/images/agenda/agenda.png",
    };
  },
});
